import { render, staticRenderFns } from "./NetworkError.vue?vue&type=template&id=5b3436ea&"
import script from "./NetworkError.vue?vue&type=script&lang=js&"
export * from "./NetworkError.vue?vue&type=script&lang=js&"
import style0 from "./NetworkError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/NetworkError.vue
// module id = null
// module chunks = 